import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { buildMenu } from './buildMenu';
import { CollapsibleGroup } from './CollapsibleGroup';
import type { ITypeSectionProps } from './ITypeSectionProps';
import { typeSectionTitle } from './menuEntries';
import { TypeSectionItems } from './TypeSectionItems';

/**
 * Розгортний розділ типу запису в модулі з реалізованими дочірніми таблицями (прототип v4, «Верховна Рада»): заголовок — назва типу
 * (тип, названий як модуль, — за пунктом «Усі …»), типово розгорнутий лише поточний тип; вибір користувача зберігається для модуля.
 */
export function TypeSection({ ws, moduleKey, moduleName, rt, planning, current, openState }: ITypeSectionProps) {
  const strings = useModuleStrings();
  const id = `type:${rt.key}`;
  const entries = buildMenu(rt, {}, strings, moduleName).flatMap((s) => s.entries);
  const title = typeSectionTitle(strings.entity(rt.key, 'name', rt.name), moduleName, entries);
  return (
    <CollapsibleGroup title={title} open={openState.isOpen(id, current)} onToggle={() => openState.toggle(id, current)}>
      <TypeSectionItems ws={ws} moduleKey={moduleKey} moduleName={moduleName} rt={rt} planning={planning} />
    </CollapsibleGroup>
  );
}
